// Catalog.ID Client — Profile API
// ============================================================================

import { api } from './client';
import type { PublicProfile } from './types';

export async function getPublicProfile(cid: string): Promise<PublicProfile> {
    return api.get(`/api/profile/${cid}`);
}
